import sortable from "html5sortable/src/html5sortable";
import naja from "naja";
import {Ajax} from "../../components/ajax";
import {Popover} from "bootstrap";

export default function(html) {
	naja.initialize()

	const ajax = new Ajax(html)
	ajax.onAfterUpdate((root) => {
		if (root.classList.contains('rules')) {
			init(root.parentElement)
		} else {
			init(root)
		}
	})

	init(html)
}

function init (root) {
	if (root.querySelector('.rules.sortable')) {
		sortable('.rules.sortable', {
			forcePlaceholderSize: true,
			handle: '.fa-arrows'
		})[0].addEventListener('sortupdate', (e) => {
			const url = e.detail.item.dataset.sortUpdateUrl
			if (url) {
				naja.makeRequest('GET', url, {index: e.detail.destination.index}, {history: false}).catch((err) => {
					alert(err)
				})
			}
		})
	}

	Array.from(root.querySelectorAll('.rule-text-preview')).forEach((el) => {
		el.addEventListener('click', (e) => {
			const popover = Popover.getOrCreateInstance(e.currentTarget)
			const content = document.createElement('div')
			content.classList.add('bg-danger-subtle')
			content.classList.add('p-2')
			content.classList.add('rounded')
			content.innerText = e.currentTarget.previousElementSibling.value

			popover.setContent({
				'.popover-body': content
			})
		})
	})

	for (const q of ['.rule', '.rule-set']) {
		Array.from(root.querySelectorAll(q + ' form input[type=text]')).forEach((el) => {
			let t = null;
			el.addEventListener('keyup', (e) => {
				e.currentTarget.dataset.selectionEnd = e.currentTarget.selectionEnd

				if (t) {
					clearTimeout(t)
				}

				t = setTimeout(() => {
					submitForm(e.target.form)
				}, 500)
			})

			el.addEventListener('mouseup', (e) => {
				e.currentTarget.dataset.selectionEnd = e.currentTarget.selectionEnd
			})
		})

		Array.from(root.querySelectorAll(q + ' form select[name*="[operator]"], ' + q + ' form select[name*="[value]"], ' + q + ' form input[name*="[value]"]')).forEach((el) => {
			el.addEventListener('change', (e) => {
				submitForm(e.target.form)
			})
		})

		Array.from(root.querySelectorAll(q  + ' form button[type=submit]')).forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()
				submitForm(e.target.closest('form'))
			})
		})
		
		Array.from(root.querySelectorAll(q + ' a.add-variable')).forEach(el => {
			el.addEventListener('click', (e) => {
				e.preventDefault()

				const url = e.currentTarget.getAttribute('href')
				const input = e.currentTarget.closest('.rule, .rule-set').querySelector('input[type=text]')
				let position = null
				if (input) {
					position = input.dataset.selectionEnd
				}

				naja.makeRequest('GET', url, {position: position}, {history: false}).catch((err) => {
					alert(err)
				})
			})
		})
	}
}

function submitForm(html) {
	const saving = html.closest('.card').querySelector('.saving')
	const lastUpdate = html.closest('.card').querySelector('.last-update')
	saving.classList.remove('d-none')

	naja.uiHandler.submitForm(html, {history: false}).then((payload) => {
		if (payload.success) {
			if (payload.lastUpdate) {
				lastUpdate.innerHTML = payload.lastUpdate
			}

			setTimeout(() => {
				saving.classList.add('d-none')
			}, 500)
		} else {
			saving.classList.add('d-none')
		}
	}).catch((err) => {
		alert(err)
	})
}
